app.service('permissionModal', function (modal) {

	function open(id) {
		modal.open('permission-modal-' + id);
	}

	function setEvents() {
		$('body').on('click', '.js-show-permission-modal', function (event) {
			open($(event.target).data('id'));
		});
	}

	function init() {
		setEvents();
	}

	return {
		init
	};
});
